import {
  FormControl,
  FormHelperText,
  InputLabel,
  Link,
  Typography,
  makeStyles,
} from '@material-ui/core'
import clsx from 'clsx'
import { useField } from 'formik'
import AddCircleIcon from '@material-ui/icons/AddCircle'
import DeleteIcon from '@material-ui/icons/Delete'
import React, { useRef } from 'react'

import Button from './Button'

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: 'white',
    borderRadius: theme.shape.borderRadius,
    height: 56,
    minWidth: 135,
    overflow: 'hidden',
    padding: '25px 12px 3px',
  },
  addFile: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
  },
  addButton: {
    whiteSpace: 'nowrap',
    marginRight: theme.spacing(0.5),
  },
  deleteIcon: {
    cursor: 'pointer',
    marginLeft: theme.spacing(1),
  },
  input: {
    display: 'none',
  },
  linkArea: {
    alignItems: 'flex-start',
    display: 'flex',
    flexDirection: 'row',
  },
}))

const FormikFileField = ({
  accept = 'application/pdf',
  className,
  fullWidth,
  label,
  margin,
  name,
  variant,
}) => {
  const classes = useStyles()
  const [field, meta] = useField({ name })
  const { touched, error } = meta
  const { onChange, value } = field
  const hasError = Boolean(touched && error)

  const fileInput = useRef()

  const isFile = value instanceof File
  const downloadLink = !isFile && value

  const handleChange = value => onChange({ target: { name, value } })
  const handleChangeFile = event => handleChange(event.currentTarget.files[0])
  const handleClickDelete = event => {
    event.preventDefault()
    fileInput.current.value = ''
    handleChange(null)
  }

  const handleAreaClick = event => {
    // Allow links to link through otherwise stop click event triggering file
    // selection dialog
    if (event.target.nodeName !== 'A') {
      event.preventDefault()
    }
  }

  return (
    <FormControl
      className={clsx(classes.root, className)}
      margin={margin}
      error={Boolean(error)}
      fullWidth={fullWidth}
      variant={variant}
    >
      <InputLabel error={Boolean(error)} shrink>
        {label}
      </InputLabel>
      <label>
        {!value ? (
          <Button
            className={classes.addButton}
            onClick={() => fileInput.current.click()}
            size="small"
            startIcon={<AddCircleIcon />}
            color="primary"
            variant="text"
          >
            Select file
          </Button>
        ) : downloadLink ? (
          <Typography className={classes.linkArea} onClick={handleAreaClick}>
            <Link href={downloadLink} target="_blank">
              Download
            </Link>
            <DeleteIcon
              className={classes.deleteIcon}
              fontSize="small"
              onClick={handleClickDelete}
            />
          </Typography>
        ) : (
          <Typography className={classes.linkArea} onClick={handleAreaClick}>
            <span>{value.name}</span>
            <DeleteIcon
              className={classes.deleteIcon}
              fontSize="small"
              onClick={handleClickDelete}
            />
          </Typography>
        )}
        <input
          className={classes.input}
          accept={accept}
          onChange={handleChangeFile}
          ref={fileInput}
          type="file"
        />
      </label>
      {hasError && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  )
}

FormikFileField.defaultProps = {
  variant: 'filled',
}

export default FormikFileField
